module.exports = __webpack_public_path__ + "img/ic_no_professional_reference.7263667b.svg";